import PropTypes from 'prop-types';
import React, { Component } from "react";
import Relay from "react-relay"
import State from "../../stores/State"
import { dispatch } from "../../Dispatcher"
import { Link } from "react-router"
import Icon from "../elements/Icon"
import SetResources from "../modules/SetResources"
import SearchDisplayTools from "../modules/SearchDisplayTools"
import { FormattedMessage } from "react-intl"
import { default as setsMessages } from "../../messages/sets"
import { width } from "../../scripts/size"
import { setArticleStyle } from "../../actions"
import { SET_ARTICLE_STYLES, MOBILE_ARTICLE_STYLE_ID } from "../../constants"
import { getStyles, getStyleTag } from '../../styles/dynamicStyles'

class PublicSet extends Component {
  state = {
    articleStyle: State.get("articleStyle"),
    articleStyles: SET_ARTICLE_STYLES,
  }

  componentDidMount() {
    this.handleArticleStyles()
    this._stateListener = State.addListener(() => {
      const articleStyle = State.get("articleStyle")
      if (articleStyle !== this.state.articleStyle) {
        this.setState({ articleStyle })
      }
    })
    window.addEventListener("resize", this.handleArticleStyles)
  };

  componentWillUnmount() {
    if (this._stateListener) {
      this._stateListener.remove()
    }
    window.removeEventListener("resize", this.handleArticleStyles)
  }

  handleArticleStyles = () => {
    if (width() <= 512) {
      this.setState({ articleStyle: MOBILE_ARTICLE_STYLE_ID })
      dispatch(setArticleStyle(MOBILE_ARTICLE_STYLE_ID))
    }
  }

  render() {
    const { userSet } = this.props
    const { articleStyle, articleStyles } = this.state

    return userSet ? (
      <main id="main" role="main" tabIndex={0}>
        {getStyleTag(['rich-page-header__content', 'rich-page-header__subtitle'])}
        <div className="rich-page-header" style={getStyles('rich-page-header')}>
          <div className="rich-page-header__content"
               style={getStyles('rich-page-header__content')}>
            <div className="row column" style={getStyles('rich-page-header__content__row')}>
              <h1 className="rich-page-header__title" 
                  style={getStyles('rich-page-header__title')}>
                {userSet.name}
              </h1>
              {/* userSet.author &&
                <p className="rich-page-header__text">{userSet.author}</p>
              */}
              <h3 className="rich-page-header__subtitle inverse">
                <Link to="/sets">
                  <Icon icon="arrow-left" /> 
                  <FormattedMessage {...setsMessages.backToAllSets} />
                </Link>
              </h3>
            </div>
          </div>
        </div>

        <div className="page column row">
          <div className="search-results__tools search-results__tools--inpage">
            <div className="column row">
              <div className="search-results__tools-inner">
                <div className="c-results-panel search-results__panel search-results__panel--full" 
                     style={getStyles('search-results__panel')}>
                <SearchDisplayTools articleStyles={articleStyles} withSort={false} />
                </div>
              </div>
            </div>
          </div>
          <SetResources userSet={userSet} articleStyle={articleStyle}/>
        </div>
      </main>
    ) : (
      <p>Loading</p>
    )
  }
}

PublicSet.propTypes = {
  userSet: PropTypes.object
}

export default Relay.createContainer(PublicSet, {
  fragments: {
    userSet: () => Relay.QL`
      fragment on UserSet {
        name
        ${SetResources.getFragment("userSet")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/PublicSet.js